import { ResourceCenterStrings } from "./resource-center-strings.js";
import { htmlDecode } from "./resource-center-sanitize.js";

export class ResourceCenterFilterService {
  constructor(settings) {
    this.filterSettings = settings;
  }

  getSelection() {
    let selectedTaxonomies = [];
    if (this.filterSettings.TaxonomySelectors && this.filterSettings.TaxonomySelectors.length > 0) {
      this.filterSettings.TaxonomySelectors.forEach(selector => {
        const currentTaxon = this.getSelectedTaxonomies(selector);
        if (Object.keys(currentTaxon).length > 0) {
          selectedTaxonomies.push(currentTaxon)
        }
      });
    }

    const language = this.getSelectedLanguage();
    const searchTerm = this.getSearchParams();

    // WUG specific
    this.toggleClearFiltersButton(selectedTaxonomies);

    return { selectedTaxonomies, language, searchTerm };
  }

  markSelectedItemsBasedOnQueryParams(queryParams) {
    let querryParamsPertainingToFilterSelection = [
      ResourceCenterStrings.languageKeyName,
      ResourceCenterStrings.searchtextKeyName
    ]

    const customQueryParams = this.getQueryParamsFromDom();
    querryParamsPertainingToFilterSelection = querryParamsPertainingToFilterSelection.concat(customQueryParams);

    for (let currentKey of querryParamsPertainingToFilterSelection) {
      if (queryParams.has(currentKey)) {
        switch (currentKey) {         
          case ResourceCenterStrings.languageKeyName:
            this.setSelectedLanguage(queryParams.get(currentKey));
            break;
          case ResourceCenterStrings.searchtextKeyName:
            this.populateSearchField(htmlDecode(queryParams.get(currentKey)));
            break;
          default:
            let keyValues = queryParams.getAll(currentKey);
            for (let currentValue of keyValues) {
              this.markElementAsSelected("data-name", currentValue);
            }
            break;
        }
      }
    }
  }

  getSelectedTaxonomies(selector) {
    let taxonomies = {};
    let selectedTaxonomies = this.getTaxonomiesDomSelection(selector);

    if (selectedTaxonomies.length === 0) {
      return taxonomies;
    }

    selectedTaxonomies.forEach(taxon => {
      const taxonomyName = taxon.getAttribute("taxonomy");
      if (taxonomyName) {
        const parent = taxon.closest("[taxaOperator][taxonomyOperator][taxonomy='" + taxonomyName + "']");
        const taxonomyOperator = parent ? parent.getAttribute("taxonomyOperator") : 'and';
        const taxaOperator = parent ? parent.getAttribute("taxaOperator") : 'or';

        let taxaId = [];
        const taxonDataSet = taxon.dataset;
        if (taxonDataSet && taxon.dataset.id) {
          taxaId = taxon.dataset.id.split(",");
        }
        else {
          taxaId.push(taxon.getAttribute("id"));
        }

        if (taxonomies.hasOwnProperty(taxonomyName)) {
          taxonomies[taxonomyName].taxa = taxonomies[taxonomyName].taxa.concat(taxaId);
        }
        else {
          taxonomies[taxonomyName] = { taxonomyOperator: taxonomyOperator, taxaOperator: taxaOperator, taxa: taxaId };
        }
      }
    });

    return taxonomies;
  }

  getSearchParams() {
    let searchParams = "";
    let searchInputValue = "";
    if (document.getElementById(this.filterSettings.SearchSelectors.input)) {
      searchInputValue = document.getElementById(this.filterSettings.SearchSelectors.input).value;
    }

    let activeSerchMessageElement = document.querySelector(`.${this.filterSettings.SearchSelectors.activeSerchMessageElement}`);
    let activeSearchMessageTermElement = document.querySelector(`.${this.filterSettings.SearchSelectors.activeSearchMessageTermElement}`);

    if (searchInputValue && searchInputValue.length > 0) {
      searchParams += searchInputValue;
    }

    if (activeSerchMessageElement && activeSearchMessageTermElement) {
      this.toggleActiveSearchMessage(searchParams, activeSerchMessageElement, activeSearchMessageTermElement, searchInputValue);
    }

    return searchParams;
  }

  getSelectedLanguage() {
    const selector = this.filterSettings.LanguageSelector;
    if (selector) {
      const selectedLanguage = document.querySelector(`input[class=${selector}]:checked, select[class=${selector}] option:checked`);
      if (!selectedLanguage) {
        return 'en';
      }
      return selectedLanguage.id;
    }
    return '';
  }

  setSelectedLanguage(language) {
    let languageField = document.getElementById(language) || document.getElementById('en');

    if (!languageField || !language) return;

    const domElementType = languageField.tagName.toLowerCase();
    switch (domElementType) {
      case 'option':
        languageField.selected = true;
        break;
      case 'input':
        languageField.checked = true;
    }
  }

  markElementAsSelected(propertyName, propertyValue, isSelected = true) {
    try {
      const domElement = document.querySelectorAll(`[${propertyName}='${propertyValue}']`);
      if (domElement) {
        const domElementType = domElement[0].tagName.toLowerCase();
        switch (domElementType) {
          case "option":
            domElement[0].selected = isSelected;
            this.triggerItemChangeEvent(domElement[0]);
          case "input":
            domElement[0].checked = isSelected;
            this.triggerItemChangeEvent(domElement[0]);
        }
      }
    }
    catch (ex) { }
  }

  clearSelection(pageUrlService, clearContentType = true) {
    const defaultLanguage = pageUrlService.getPageLanguage();
    let languageElement = document.querySelector(`#${defaultLanguage}`);
    if (languageElement) {
      languageElement.checked = true;
    }

    this.filterSettings.TaxonomySelectors.forEach(selector => {
      let selectedTaxonomies = this.getTaxonomiesDomSelection(selector);
      selectedTaxonomies.forEach(taxon => {
        //Ipswitch and WUG do not reset their content type selection when clearing filters.
        if (taxon.name !== ResourceCenterStrings.contentTypesKeyName) {
          var taxonType = taxon.tagName.toLowerCase();
          switch (taxonType) {
            case "input":
              taxon.checked = false;
              this.triggerItemChangeEvent(taxon);
              break;
            case "option":
              taxon.selected = false;
              this.triggerItemChangeEvent(taxon);
              break;
          }
        }
      })
    });

    if (clearContentType) {
      const defaultContentType = document.querySelector("input[title='all-resources']");
      if (defaultContentType) {
        defaultContentType.checked = true;
      }
    }

    this.populateSearchField("");
  }

  triggerItemChangeEvent(item) {
    item.dispatchEvent(new Event('change'));
  }

  populateSearchField(value) {
    let searchField = document.getElementById(this.filterSettings.SearchSelectors.input);
    if (searchField) {
      document.getElementById(this.filterSettings.SearchSelectors.input).value = value;
    }
  }

  toggleActiveSearchMessage(searchParams, activeSerchMessageElement, activeSearchMessageTermElement, searchInputValue) {
    if (searchParams) {
      activeSerchMessageElement.classList.remove("-dn")

      activeSearchMessageTermElement.innerText = searchInputValue;
    }
    else {
      activeSerchMessageElement.classList.add("-dn");

      activeSearchMessageTermElement.innerText = "";
    }
  }

  toggleClearFiltersButton(selectedTaxonomies) {
    if (this.filterSettings.ResourceFactorySettings && this.filterSettings.ResourceFactorySettings.ResourceItemHtmlProviderName === "WUG" && selectedTaxonomies) {
      const attributeName = 'data-resource-filter';
      const body = document.querySelector('body');
      selectedTaxonomies.length > 0 ? body.setAttribute(attributeName, 'true') : body.removeAttribute(attributeName);
    }
  }

  getTaxonomiesDomSelection(selector) {
    const selectedTaxonomiesInput = Array.from(document.querySelectorAll(`.${selector}:checked`));
    const selectedTaxonomiesOption = Array.from($(`.${selector}`).find(":selected"));
    const selectedTaxonomies = selectedTaxonomiesInput.concat(selectedTaxonomiesOption);

    return selectedTaxonomies;
  }
  getQueryParamsFromDom() {
    const attributeName = "taxonomy";
    const domItemsMarkedWithQueryParamsAttribute = Array.from(document.querySelectorAll(`[${attributeName}]`));
    let queryParams = [];

    domItemsMarkedWithQueryParamsAttribute.forEach(queryParam => {
      const queryParamKey = queryParam.getAttribute(attributeName);
      // The "new Set()" collection is not supported by IE 11;
      if (queryParams.indexOf(queryParamKey) === -1) {
        queryParams.push(queryParamKey);
      }
    });

    return queryParams;
  }
}
